import { Component, Output, EventEmitter } from '@angular/core';

declare const $: any;

@Component({
    selector: 'app-separation-result-modal',
    templateUrl: './separation-result-modal.component.html',
    styleUrls: ['./separation-result-modal.component.scss']
})
export class SeparationResultModalComponent {
    @Output() choiceUnify = new EventEmitter<void>();
    @Output() choiceAlone = new EventEmitter<void>();

    open(): void {
        $('#separationResultModal').modal('show');
    }

    close(): void {
        $('#separationResultModal').modal('hide');
    }

    onUnify(): void {
        this.close();
        this.choiceUnify.emit();
    }

    onAlone(): void {
        this.close();
        this.choiceAlone.emit();
    }
}
